import { createContext } from 'react';

const globalContenxt = createContext();

export default globalContenxt;